import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import Store from '../Store/Store'
import Request from '../Request/Request'
import getData from '../Admin/getData'
import Menu from '../Admin/Menu'
import Header from '../Admin/Header'
import Rows from '../Admin/Rows'
import Update from './Update/Update'
import Center from "../App/Center"
import UploadFile from '../Admin/UploadFile'

export default function Admin( props ) {

	const navigate = useNavigate()
	const user = Store.get( 'user' )

	const [ tmp, setTmp ] = useState( 1 )

	const [ tab, setTab ] = useState( 'bookings' )
	const [ tabs, setTabs ] = useState( Store.get( 'tables' ) || [] )
	const tabKey = "table_name"
	const tabLabel = "table_name"

	const table = tab || 'bookings'

	const [ structure, setStructure ] = useState( Store.get( 'structure' ) || {} )
	const [ rows, setRows ] = useState( Store.get( 'rows/' + table ) ||  [] )
	const [ rowId, setRowId ] = useState( false )

	if ( !user ) navigate( '/' )

	useEffect(() => {

		getData( 'structure', setStructure, d => Store.set( 'structure', d ) )

		getData( 'tables', null, data => { 

			const index = data.findIndex( row => row.table_name === 'admin_log' )
			const d = data.toSpliced( index, 1 )

			setTabs( d )
			Store.set( 'tables', d ) 

			if ( d && d.length > 0 && tab === null ) {
				setTab( d[ 0 ].table_name )
			}

		} )

		if ( user && user.token ) {
			Request.get( 'token', d => {
				if ( !d.data.token ) { 
					Store.set( 'user', null )
					navigate( '/login' )
				}
			} )
		}

	}, [] )

	useEffect(() => {
		if ( tab !== null ) {
			getData( 'rows/' + tab, setRows, d => Store.set( 'rows-' + tab, d ) )
		}
	}, [ tab, rowId ] ) ;

	const commonProps = { tabs, tab, setTab, tabKey, tabLabel, structure, table, rowId, setRowId, rows, setRows }

	return <>
		<div style={{
			width:'100%', minHheight:'100%', color:'#000'
		}} >
			<Menu updateContent={ props.updateContent } { ...commonProps }  />
			{ rowId 
			? <Update { ...commonProps } />
			: <table style={{ fontSize:13, marginLeft:20 }} >
				<tbody>
					<Header { ...commonProps } />
					<Rows { ...commonProps } />
				</tbody>
			  </table>
			}
		</div>
	</>

	return <>
		<div style={{
			width:'100%', minHheight:'100%', color:'#000', 
		}} >
			<Center marginStyle={{ background:'#00000000' }} >
				<Menu updateContent={ props.updateContent } { ...commonProps }  />
			</Center>	
			{ rowId 
			? <Update { ...commonProps } />
			: <table style={{ fontSize:13, marginLeft:20 }} >
				<tbody>
					<Header { ...commonProps } />
					<Rows { ...commonProps } />
				</tbody>
			  </table>
			}
		</div>
	</>


}
